import { GetStaticPaths, GetStaticProps } from 'next'

import api from 'lib/api'
import { VacancyView } from './components/vacancy-view'

const VacancyPage = props => (
  <VacancyView vacancy={props.vacancy} company={props.company} />
)

export const getStaticPaths: GetStaticPaths = () => {
  return { paths: [], fallback: 'blocking' }
}

export const getStaticProps: GetStaticProps = async context => {
  const id = context.params.id

  try {
    const { data: vacancy } = await api<{ id?: number }>(`/vacancies/${id}`)

    if (vacancy?.id) {
      return {
        props: { vacancy },
        revalidate: 60 * 7 // 7min
      }
    }
  } catch (err) {
    console.error('ISR ERROR', err)
  }

  return { notFound: true, revalidate: 20 }
}

export default VacancyPage
